import GeneralLedger from '@/genleg/GeneralLedger.vue'
import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import GeneralLedgerTransList from '@/genleg/GeneralLedgerTransList.vue'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {usePanelManager} from '@tritt/multipanel'
import {h} from 'vue'
import SimpleCrumb from '@/breadcrumbs/SimpleCrumb.vue'
import AccountCrumb from '@/bookkeeping-account/AccountCrumb.vue'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import FatTribal from '@/tribal/FatTribal.vue'
import {getFeatureValue} from '@/feature-toggles/feature-toggler.service'
import {NEW_GENLEG_TRIBAL_FT_KEY} from '@/tribal'

export const GENERAL_LEDGER = {componentName: 'GeneralLedger', component:  getFeatureValue(NEW_GENLEG_TRIBAL_FT_KEY) ? FatTribal : GeneralLedger, meta: {requiresOrg: true}, queryValues: {defaultGridState: 'OPEN'}}
export const GENERAL_LEDGER_TRANS_LIST = {componentName: 'GeneralLedgerTransList', component: GeneralLedgerTransList, meta: {requiresOrg: true}}

const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb, registerBreadCrumbGetter} = useBreadCrumbs()


const icon = 'i-ph-book-bookmark-fill'
const label = 'Hovedbok'
const hotkey = 'w'


registerNavigationCommand({
    route: GENERAL_LEDGER,
    hotkey,
    icon,
    label
})
registerNavigationEntry(NavGroup.REPORTS, {
        title: label,
        key: 'general-ledger',
        icon,
        target: GENERAL_LEDGER,
        sortOrder: 2
    }
)

registerRoute(GENERAL_LEDGER)
registerHotkey(hotkey, GENERAL_LEDGER)
registerBreadCrumbGetter(() => {
    const {currentPanelContent} = usePanelManager()
    if (currentPanelContent.value?.componentName !== GENERAL_LEDGER.componentName) {
        return
    }
    if (currentPanelContent.value?.props?.accountNo) {
        return [
            h(SimpleCrumb, {name: 'Hovedbok', icon, to: GENERAL_LEDGER, reportsPrefix: true}),
            h(AccountCrumb, {accountNo: currentPanelContent.value.props.accountNo})
        ]
    } else {
        return h(SimpleCrumb, {name: 'Hovedbok', icon, to: GENERAL_LEDGER, reportsPrefix: true})
    }
})

registerRoute(GENERAL_LEDGER_TRANS_LIST)
registerNavigationEntry(NavGroup.REPORTS, {
    title: 'Hovedbok - Transaksjonsliste',
    key: 'genleg-translist',
    icon,
    target: GENERAL_LEDGER_TRANS_LIST,
    sortOrder: 3
})
buildSimpleCrumb(GENERAL_LEDGER_TRANS_LIST, 'Hovedbok - Transaksjoner', icon, true)